import { Space as ReactSpace } from "@certn/cascadia-react/foundations/grid-layout/Layout";
import { memo } from "react";

export const Space = memo(function () {
  return <ReactSpace />;
});
